import { render } from "./FileDownload.vue?vue&type=template&id=7965e317&scoped=true"
import script from "./FileDownload.vue?vue&type=script&lang=js"
export * from "./FileDownload.vue?vue&type=script&lang=js"

import "./FileDownload.vue?vue&type=style&index=0&id=7965e317&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7965e317"]])

export default __exports__